<template src="./searchNavComponent.template.html"></template>


<script>
    import moment from "moment-timezone";
    import vueSlider from '../../sliderComponent/vue-slider/';

    import { IntegerPlusminus } from 'vue-integer-plusminus';
    export default {

        name: 'booking-eng',
        props: [],
        components: {
            vueSlider,
            IntegerPlusminus
        },
        data() {
            return {
                updateCalendar: false,
                disablePrevDates: true,
                IsDatesFilter: false,
                showApplyAndCancelBtn: false,
                mapWidth: "",
                pannel: true,
                showError: false,
                showguestError: false,
                showAdultError: false,
                showChildrenError: false,
                disbleSelectButton: true,
                isTrueOrFalse: true,
                showCalenderError: false,
                // showit: false,
                // showNav: false,
                showMobileSearch: false,
                amenitiesList: [],
                locationsList: [],
                availableRoomsList: [],
                autoApply: true,
                opens: "left",

                guestList: [],
                guestListAdults: [],
                guestListChildren: [],
                showguestdropdown: false,
                showAdultandChildrenDropdown: false,
                locationsList: [],
                filterObj: {
                    value: [null, null],
                    Persons: -99,
                    Adults: -99,
                    Children: -99,
                    startDate: moment.utc().format("YYYY-MM-DD"),
                    endDate: moment.utc().format("YYYY-MM-DD"),
                    // startDate: "",
                    // endDate: "",
                    Location: -99,
                    //Location: {CityId:null,CityName:"Kota Bandung"},
                    ClientId: 7,
                    FilteredAmenities: [],
                    amenitiesFiltered: [],
                    Beds: 0,
                    Bathrooms: 0,
                    Beds: 0,
                    Bedrooms: 0,
                    PageNo: 1,
                    ItemsPerPage: 20,
                    unitId: null,
                    RatePlanId: null,
                    Promocode: null
                },
                isShow: true,
                showSearch: true,
                demo3: {
                    value: [0, 100],
                    width: '100%',
                    height: 8,
                    dotSize: 16,
                    min: 0,
                    max: 2000,
                    disabled: false,
                    show: true,
                    useKeyboard: true,
                    tooltip: 'always',
                    formatter: '${value}',
                    enableCross: false,
                    mergeFormatter: '${value1} ~ ${value2}',
                    bgStyle: {
                        backgroundColor: '#fff',
                        boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
                    },
                    tooltipStyle: {
                        backgroundColor: '#666',
                        borderColor: '#666'
                    },
                    processStyle: {
                        backgroundColor: '#999'
                    }
                },
                defaultPrices: [],
                scrollPOS: {},
                // setPosition: {
                //     position: 'relative',
                //     top: '12px'
                // },
                // afterScrolledStyle: { top: '100px' },
                showguestActive: false,
                showAdultActive: false,
                // showDatesActive:false,
                hideSearch: true,
                showfiltereditpanelmask: false,
                defaultSelection: {},
                minDate: ""
            };
        },
        methods: {
            updateDisablePrevDates(value) {
                this.disablePrevDates = value;
            },
            closeHeaderPannel() {
                let vm = this;
                vm.showSearch = false;
                vm.$store.state.filterObj.startDate = null;
                vm.$store.state.filterObj.endDate = null;
                // vm.$store.state.filterObj.Persons = -99,
                //     vm.$store.state.filterObj.Adults = -99,
                //     vm.$store.state.filterObj.Children = -99,
                //     vm.$store.state.filterObj.Location = -99,
                if (vm.defaultSelection.GuestPattern == "Persons") {
                    vm.$store.state.filterObj.Persons = vm.defaultSelection.DefaultnoofGuests == 0 ? 2 : vm.defaultSelection.DefaultnoofGuests;
                    vm.filterObj.Persons = vm.defaultSelection.DefaultnoofGuests == 0 ? 2 : vm.defaultSelection.DefaultnoofGuests;
                }
                else {
                    vm.$store.state.filterObj.Children = vm.defaultSelection.Defaultnoofchildren == 0 ? -99 : vm.defaultSelection.Defaultnoofchildren;
                    vm.$store.state.filterObj.Adults = vm.defaultSelection.Defaultnoofadults == 0 ? 2 : vm.defaultSelection.Defaultnoofadults;
                    vm.filterObj.Children = vm.defaultSelection.Defaultnoofchildren == 0 ? -99 : vm.defaultSelection.Defaultnoofchildren;
                    vm.filterObj.Adults = vm.defaultSelection.Defaultnoofadults == 0 ? 2 : vm.defaultSelection.Defaultnoofadults;
                }


                if (vm.defaultSelection.DefaultLocationName != -99) {
                    let selectedDefaultLocation = vm.locationsList.filter(function (item) {
                        return item.CityName == vm.defaultSelection.DefaultLocationName
                    })[0];
                    vm.$store.state.filterObj.Location = selectedDefaultLocation
                    vm.filterObj.Location = selectedDefaultLocation
                } else {
                    vm.$store.state.filterObj.Location = vm.defaultSelection.DefaultLocationName
                    vm.filterObj.Location = vm.defaultSelection.DefaultLocationName
                }
                vm.filterObj.startDate = null
                vm.filterObj.endDate = null


                // if (vm.defaultSelection.DefaultLocationName != -99) {
                //     vm.filterObj.Location = vm.locationsList.filter(function (item) {
                //         return item.CityName == vm.defaultSelection.DefaultLocationName
                //     })[0];
                // }
                this.showSearch = false;
                this.hideSearch = true;
                this.pannel = false;
                vm.filterObj.Promocode = null
                setTimeout(() => {
                    this.isShow = true
                }, 400);
                document.getElementById("custom-nav-bar").style.display = "";
                vm.IsDatesFilter = false;
                document.getElementById("page-content").style.padding = "";
                // document.getElementsByClassName(".searchWrap.DatesFilter").style.marginTop = "0px";
                // $('.searchWrap.DatesFilter').css("margin-top",  0);

                vm.$store.state.bus.$emit("hidesearchResults", false);
                vm.$store.state.bus.$emit("hidingSearch", true);
                vm.getAvailableRooms();
                vm.$store.state.bus.$emit("hideMaskpanel", false);
                vm.isShow = true;
                vm.showfiltereditpanelmask = false
            },
            showclear(showclear) {
                let vm = this;
                // console.log("flag", flag)

                // if (flag == "hideClearFilters") {
                vm.isShow = false;
                vm.filterObj.FilteredAmenities.splice(0)
                for (let ami of vm.amenitiesList) {
                    ami.isChecked = false
                }
                // vm.filterObj.startDate = null,
                // vm.filterObj.endDate = null,
                // vm.filterObj.Persons = -99,
                // vm.filterObj.Adults = -99,
                // vm.filterObj.Children = -99,
                // vm.filterObj.Location = -99,
                vm.filterObj.Beds = 0,
                    vm.filterObj.Bathrooms = 0,
                    vm.filterObj.Beds = 0,
                    vm.filterObj.Bedrooms = 0,
                    vm.filterObj.value = vm.defaultPrices,
                    // vm.getAvailableRooms(showclear);
                    vm.$store.state.bus.$emit('callForAmenities', vm.amenitiesList);


                vm.getAvailableRooms();
                // }
                // if (flag == "clearFilters") {
                //     // vm.isclearShow = false;

                //     vm.filterObj.FilteredAmenities.splice(0)
                //     for(let ami of vm.amenitiesList){
                //         ami.isChecked = false
                //     }
                //      vm.filterObj.Beds = 0,
                //         vm.filterObj.Bathrooms = 0,
                //         vm.filterObj.Beds = 0,
                //         vm.filterObj.Bedrooms = 0,
                //         vm.filterObj.value = [159, 349],

                //     vm.getAvailableRooms();
                //     vm.$store.state.bus.$emit('callForAmenities', vm.amenitiesList);


                // }
                vm.$store.state.bus.$emit("hideMaskpanel", false);
                vm.$store.state.bus.$emit("hidingSearch", true);
                vm.isShow = true;
                vm.showfiltereditpanelmask = false
            },
            closePannel() {
                let vm = this;
                console.log("dhddddddddddddddddddddddddddddddddddddddddd")
                vm.showSearch = false;
                vm.hideSearch = true;
                vm.pannel = false;
                setTimeout(() => {
                    vm.isShow = true
                }, 400);
            },
            changeError() {
                let vm = this;
                vm.showError = false;
            },

            checkDates(values) {
                let vm = this;
                console.log("values checkDates", values)
                if (values.isTrueOrFalse) {
                    vm.isTrueOrFalse = true;
                    // vm.setAvailableUnitsData();
                    // vm.GetFiltersData_BE();
                    // Object.assign(this.$data, this.$options.data());
                    // vm.setAvailableUnitsData();
                    // vm.GetFiltersData_BE();
                    // vm.getAvailableRooms();
                }
                else {
                    vm.isTrueOrFalse = false;
                }
            },

            // checkedValues(value, event) {
            //     let vm = this;
            //     console.log("checkedValues", value + " " + event.target.checked);


            //     if (event.target.checked == true) {
            //         console.log("here", value)
            //         var index = vm.amenitiesList.indexOf(value);
            //         if (index > -1) {
            //             vm.amenitiesList.splice(index, 1);
            //         }
            //         vm.filterObj.FilteredAmenities.push(value.ListId);
            //         vm.filterObj.amenitiesFiltered.push(value);

            //     }
            //     else if (event.target.checked == false) {
            //         var index = vm.filterObj.FilteredAmenities.indexOf(value.ListId);
            //         if (index > -1) {
            //             vm.filterObj.FilteredAmenities.splice(index, 1);
            //         };

            //         var index = vm.filterObj.amenitiesFiltered.indexOf(value);
            //         if (index > -1) {
            //             vm.filterObj.amenitiesFiltered.splice(index, 1);
            //         };
            //         vm.amenitiesList.push(value);
            //     }
            //     console.log("vm.filterObj.FilteredAmenities", vm.filterObj.FilteredAmenities);
            // },
            checkedValues(Aminity, e) {
                if (e.target.checked) {
                    return;
                } else {
                    var index = this.amenitiesList.indexOf(Aminity);
                    this.amenitiesList[index].IsChecked = 0;
                    var index2 = this.amenitiesList.indexOf(Aminity.ListId);
                    if (index2 > -1) {
                        this.filterObj.FilteredAmenities.splice(index2, 1);
                        console.log(" this.filterObj.FilteredAmenities", this.filterObj.FilteredAmenities);

                        // vm.filterObj.FilteredAmenities.push(Aminity.ListId);
                    }

                }
            },



            updateValues(values) {
                let scope = this;
                console.log(values);
                // console.log("startText", startText)

                scope.filterObj.startDate = moment(values.startDate).format("YYYY-MM-DDTHH:mm:ss");
                scope.filterObj.endDate = moment(values.endDate).format("YYYY-MM-DDTHH:mm:ss");
                console.log("scope.filterObj.startDate", scope.filterObj.startDate);
                // scope.setAvailableUnitsData();
                scope.$store.state.bus.$emit("startAndEndTexts", { startDate: scope.filterObj.startDate, endDate: scope.filterObj.endDate });
                scope.showCalenderError = false;

            },
            show(flag) {

                let vm = this;
                if (flag == "showFilters") {
                    vm.isShow = false;
                    vm.pannel = true;
                }
                else {
                    vm.isShow = true;
                    vm.pannel = false;
                    vm.showfiltereditpanelmask = false
                    vm.showSearch = false;
                    vm.$store.state.bus.$emit("hideMaskpanel", false);
                    vm.isShow = true;
                    vm.showfiltereditpanelmask = false
                }

            },
            showclear(showclear) {
                let vm = this;
                // console.log("flag", flag)

                // if (flag == "hideClearFilters") {
                vm.isShow = false;
                vm.filterObj.FilteredAmenities.splice(0)
                for (let ami of vm.amenitiesList) {
                    ami.isChecked = false
                }
                // vm.filterObj.startDate = null,
                // vm.filterObj.endDate = null,
                // vm.filterObj.Persons = -99,
                // vm.filterObj.Adults = -99,
                // vm.filterObj.Children = -99,
                // vm.filterObj.Location = -99,
                vm.filterObj.Beds = 0,
                    vm.filterObj.Bathrooms = 0,
                    vm.filterObj.Beds = 0,
                    vm.filterObj.Bedrooms = 0,
                    vm.filterObj.value = vm.defaultPrices,
                    // vm.getAvailableRooms(showclear);
                    vm.$store.state.bus.$emit('callForAmenities', vm.amenitiesList);


                // vm.getAvailableRooms();
                // }
                // if (flag == "clearFilters") {
                //     // vm.isclearShow = false;

                //     vm.filterObj.FilteredAmenities.splice(0)
                //     for(let ami of vm.amenitiesList){
                //         ami.isChecked = false
                //     }
                //      vm.filterObj.Beds = 0,
                //         vm.filterObj.Bathrooms = 0,
                //         vm.filterObj.Beds = 0,
                //         vm.filterObj.Bedrooms = 0,
                //         vm.filterObj.value = [159, 349],

                //     vm.getAvailableRooms();
                //     vm.$store.state.bus.$emit('callForAmenities', vm.amenitiesList);


                // }
            },


            closeMoreOptions(flag) {
                let vm = this;
                if (flag == "hideFilters") {
                    vm.pannel = false;
                    setTimeout(() => {
                        vm.isShow = true
                    }, 400)

                }

                vm.$store.state.bus.$emit("hideMaskpanel", false);
                vm.isShow = true;
                vm.showfiltereditpanelmask = false

            },
            GetFiltersData_BE() {
                let vm = this,
                    sucessCallback = function (response) {
                        console.log("response in GetFiltersData_BE", response);
                        if (response && response.data) {
                            if (response.data[0]) {
                                vm.amenitiesList = response.data[0];
                                // for(var i = 0; i<vm.amenitiesList.length; i++){
                                //     vm.amenitiesList[i].ischecked = false;

                                // }
                                console.log(" vm.amenitiesList", vm.amenitiesList);
                            }
                            if (response.data[1]) {
                                vm.locationsList = response.data[1];
                            }
                            if (response.data[2]) {
                                vm.demo3.min = Number(response.data[2][0].MinPrice);
                                vm.demo3.max = Number(response.data[2][0].MaxPrice);
                                vm.filterObj.value = [];
                                vm.filterObj.min = Number(response.data[2][0].MinPrice);
                                vm.filterObj.max = Number(response.data[2][0].MaxPrice);
                                vm.filterObj.value.push(Number(response.data[2][0].MinPrice));
                                vm.filterObj.value.push(Number(response.data[2][0].MaxPrice));
                                vm.defaultPrices.push(Number(response.data[2][0].MinPrice))
                                vm.defaultPrices.push(Number(response.data[2][0].MaxPrice))
                            }
                            if (response.data[3]) {
                                if (response.data[3][0].MaxPersons) {
                                    let guestcount = response.data[3][0].MaxPersons;
                                    vm.showguestdropdown = true;
                                    vm.showAdultandChildrenDropdown = false;
                                    console.log("vm.guestList", guestcount);
                                    vm.guestList = [];
                                    for (let guest = 1; guest <= guestcount; guest++) {

                                        if (guest == 1) {
                                            vm.guestList.push({
                                                value: guest,
                                                Persons: guest + " " + " " + "guest",

                                            })
                                        }
                                        if (guest != 1)
                                            vm.guestList.push({
                                                value: guest,
                                                Persons: guest + " " + " " + "guests",

                                            })

                                    }
                                    console.log("vm.guestList", vm.guestList);

                                }

                                if (response.data[3][0].MaxAdults) {
                                    let guestcount = response.data[3][0].MaxAdults;
                                    vm.showAdultandChildrenDropdown = true;
                                    vm.showguestdropdown = false;
                                    console.log("vm.guestList", guestcount);
                                    vm.guestListAdults = [];
                                    for (let guest = 1; guest <= guestcount; guest++) {

                                        if (guest == 1) {
                                            vm.guestListAdults.push({
                                                value: guest,
                                                Adults: guest + " " + " " + "Adult",

                                            })
                                        }
                                        if (guest != 1)
                                            vm.guestListAdults.push({
                                                value: guest,
                                                Adults: guest + " " + " " + "Adults",

                                            })

                                    }
                                    console.log("vm.guestList", vm.guestList);
                                    // if (dropdownMenu.is(":visible")) {
                                    // $("#adultDropDown").toggleClass("open");

                                    // }
                                    // if ($("#s").attr("size") == 6) {
                                    //     $("#s").attr("size", 1);
                                    // } else {
                                    //     $("#s").attr("size", 6);

                                    // }

                                }
                                $("#adultDropDown").focus().click();
                                // $("#adultDropDown").toggleClass("open")
                                // $('#adultDropDown').focus();

                                // $('#adultDropDown .form-control').toggleClass("open");
                                if (response.data[3][0].MaxChildren) {
                                    let guestcount = response.data[3][0].MaxChildren;
                                    vm.showAdultandChildrenDropdown = true;
                                    vm.showguestdropdown = false;
                                    console.log("vm.guestList", guestcount);
                                    vm.guestListChildren = [];
                                    for (let guest = 1; guest <= guestcount; guest++) {

                                        if (guest == 1) {
                                            vm.guestListChildren.push({
                                                value: guest,
                                                Children: guest + " " + " " + "Child",

                                            })
                                        }
                                        if (guest != 1)
                                            vm.guestListChildren.push({
                                                value: guest,
                                                Children: guest + " " + " " + "Children",

                                            })

                                    }
                                    console.log("vm.guestList", vm.guestList);

                                }
                            }
                            if (response.data[4] && response.data[4][0]) {
                                vm.defaultSelection = response.data[4][0];
                                if (vm.defaultSelection.GuestPattern == "Persons") {
                                    vm.defaultSelection.DefaultnoofGuests = vm.defaultSelection.DefaultnoofGuests == 0 ? -99 : response.data[3][0].MaxPersons < vm.defaultSelection.DefaultnoofGuests ? 2 : vm.defaultSelection.DefaultnoofGuests
                                    vm.filterObj.Persons = vm.defaultSelection.DefaultnoofGuests == null ? 2 : vm.defaultSelection.DefaultnoofGuests
                                    vm.$store.state.filterObj.Persons = vm.filterObj.Persons;
                                }
                                else {
                                    vm.defaultSelection.Defaultnoofadults = vm.defaultSelection.Defaultnoofadults == 0 ? -99 : response.data[3][0].MaxAdults < vm.defaultSelection.Defaultnoofadults ? 2 : vm.defaultSelection.Defaultnoofadults
                                    vm.defaultSelection.Defaultnoofchildren = vm.defaultSelection.Defaultnoofchildren == 0 ? -99 : response.data[3][0].MaxChildren < vm.defaultSelection.Defaultnoofchildren ? -99 : vm.defaultSelection.Defaultnoofchildren
                                    vm.filterObj.Adults = vm.defaultSelection.Defaultnoofadults == null ? 2 : vm.defaultSelection.Defaultnoofadults;
                                    vm.filterObj.Children = vm.defaultSelection.Defaultnoofchildren == null ? -99 : vm.defaultSelection.Defaultnoofchildren;
                                    vm.$store.state.filterObj.Adults = vm.filterObj.Adults;
                                    vm.$store.state.filterObj.Children = vm.filterObj.Children;
                                }
                                if (vm.defaultSelection.DefaultLocationName != -99) {
                                    vm.filterObj.Location = vm.locationsList.filter(function (item) {
                                        return item.CityName == vm.defaultSelection.DefaultLocationName
                                    })[0];
                                } else {
                                    vm.filterObj.Location = vm.defaultSelection.DefaultLocationName
                                }
                                if (vm.showAdultandChildrenDropdown) {
                                    vm.filterObj.Persons = -99;
                                    vm.$store.state.filterObj.Persons = -99
                                }
                                if (vm.showguestdropdown) {
                                    vm.filterObj.Children = -99;
                                    vm.filterObj.Adults = -99;
                                    vm.$store.state.filterObj.Adults = -99
                                    vm.$store.state.filterObj.Children = -99
                                }
                                vm.$store.state.filterObj.Location = vm.filterObj.Location;

                            }
                            vm.setFilteredData();
                            if (Object.keys(vm.$route.query).length > 0) {
                                if (vm.$route.query.Location) {
                                    var LocationName = vm.$route.query.Location.replaceAll("%20", " ");
                                    if (LocationName) {
                                        var searchLocation = vm.$store.state.locationsList.filter(function (item) {
                                            return item.CityName.toUpperCase() == LocationName.toUpperCase()
                                        })[0];
                                        if (searchLocation != undefined) {
                                            vm.filterObj.Location = searchLocation;
                                        } else {
                                            vm.filterObj.Location = -99;
                                        }
                                    }
                                } else {
                                    vm.filterObj.Location = -99;
                                }

                                // if (vm.$route.query.Guests) {
                                var Guests = vm.$route.query.Guests;
                                if (Guests) {
                                    vm.filterObj.Persons = Guests;
                                } else {
                                    vm.filterObj.Persons = -99;
                                }
                                // }
                                // if (vm.$route.query.Adults) {
                                var Adults = vm.$route.query.Adults;
                                if (Adults) {
                                    vm.filterObj.Adults = Adults;
                                } else {
                                    vm.filterObj.Adults = -99;
                                }
                                // } 
                                // if (vm.$route.query.Children) {
                                var Children = vm.$route.query.Children;
                                if (Children) {
                                    vm.filterObj.Children = Children;
                                } else {
                                    vm.filterObj.Children = -99;
                                }
                                // }

                                var CheckIn = vm.$route.query.CheckIn;
                                var CheckOut = vm.$route.query.CheckOut;
                                var validRequest = true;
                                if (CheckIn != undefined && CheckOut != undefined) {
                                    if (CheckIn >= moment.utc(new Date()).format("YYYY-MM-DD") && CheckIn <= CheckOut) {
                                        vm.filterObj.startDate = moment(CheckIn).format();
                                    } else {
                                        validRequest = false;
                                        vm.filterObj.startDate = moment(CheckIn).format();
                                        vm.$store.dispatch("toastr", {
                                            type: "warning",
                                            message: "check-in date must be equal to current date and less than or equal to check-out date",
                                            header: "Warning",
                                        });
                                    }
                                    if (CheckOut >= moment.utc(new Date()).format("YYYY-MM-DD") && CheckOut >= CheckIn) {
                                        vm.filterObj.endDate = moment(CheckOut).format();
                                    } else {
                                        validRequest = false;
                                        vm.filterObj.endDate = moment(CheckOut).format(); 
                                        vm.$store.dispatch("toastr", {
                                            type: "warning",
                                            message: "check-out date must be equal to current date and greater than or equal to check-in date",
                                            header: "Warning",
                                        });
                                    }

                                    if (!validRequest) {
                                        return;
                                    }
                                    vm.updateCalendar = true;
                                }
                            }
                            //vm.$store.state.filterObj.Location = vm.filterObj.Location;
                            //vm.$store.state.filterObj.Persons = vm.filterObj.Persons;
                            //vm.$store.state.filterObj.Adults = vm.filterObj.Adults;
                            //vm.$store.state.filterObj.Children = vm.filterObj.Children;
                            //vm.$store.state.filterObj.startDate = vm.filterObj.startDate;
                            //vm.$store.state.filterObj.endDate = vm.filterObj.endDate;
                        }
                    },
                    failureCallback = function (error) {
                        console.log(error);
                    };

                vm.$store.state.sendApiRequest("beApi/GetFiltersData_BE", "post", {
                    StartDate: vm.filterObj.startDate
                    , EndDate: vm.filterObj.endDate
                }, sucessCallback, failureCallback);

            },
            addguest(value) {
                console.log("guestguest", value);
                let vm = this;
                vm.$set(vm.filterObj, "Persons", value.value);
            },
            addAdults(value) {
                console.log("guestguest", value);
                let vm = this;
                vm.$set(vm.filterObj, "Adults", value.value);
            },
            addChildren(value) {
                console.log("guestguest", value);
                let vm = this;
                vm.$set(vm.filterObj, "Children", value.value);
            },
            openguest() {
                this.showguest = true;
            },
            openAdults() {
                this.showPattern = true;
            },
            openChildren() {
                this.showChildren = true;
            },



            ApplyFilters() {
                let vm = this;
                vm.getAvailableRooms();
                vm.closeMoreOptions('hideFilters');
                vm.$store.state.bus.$emit('changeFilterLabel');
            },

            searchForAvailability() {
                let vm = this;
                vm.hideSearch = true;
                if (vm.mapWidth != 384 && vm.mapWidth != 512) {
                    vm.$store.state.bus.$emit("hidesearchResults", true);
                }

                if (vm.filterObj.Persons == -99) {
                    vm.showguestActive = true;
                }
                else {
                    vm.showguestActive = false;
                }
                if (vm.filterObj.Adults == -99) {
                    vm.showAdultActive = true;
                }
                else {
                    vm.showAdultActive = false;
                }
                // if((vm.filterObj.startDate == null || vm.filterObj.startDate == '') && (vm.filterObj.endDate == null || vm.filterObj.endDate == '') ){
                //     vm.showDatesActive = true;
                // }
                // else{
                //     vm.showDatesActive = false;
                // }
                console.log("window.outerWidth", window.outerWidth);


                if (window.outerWidth < 1920 && ((vm.filterObj.Persons != '-99') || (vm.filterObj.Adults != '-99'))) {
                    vm.showSearch = false;
                    // this.$store.state.bus.$emit("MaskingUnits", false);
                }



                if (window.innerWidth < window.innerHeight) {
                    //     var prevScrollpos = window.pageYOffset;

                    //     var currentScrollPos = window.pageYOffset;
                    //     if (prevScrollpos >= currentScrollPos) {

                    //         // this.afterScrolledStyle = { top: '20px' };
                    //         document.getElementById("customsearch").style.top = "20px";

                    if (vm.mapWidth != 384 && vm.mapWidth != 512) {
                        if (!vm.isTrueOrFalse && (vm.filterObj.Persons != '-99' || vm.filterObj.Adults != '-99')) {
                            this.$store.state.bus.$emit("hidingSearch", false);
                            // document.getElementById("custom-nav-bar").style.display = "none";
                            vm.IsDatesFilter = true;
                            document.getElementById("page-content").style.padding = "0px";
                            document.getElementById("list-countbe").style.top = "50px";

                        }
                        else {
                            console.log("openHeader");
                        }

                    }



                }
                console.log("vm.mapWidthvm.mapWidthvm.mapWidth", window.innerWidth);
                if ((window.innerHeight < window.innerWidth)) {
                    if ((window.innerWidth != 1024 && window.innerWidth != 1366 && window.innerWidth != 768)) {

                        if (!vm.isTrueOrFalse && (vm.filterObj.Persons != '-99' || vm.filterObj.Adults != '-99')) {
                            this.$store.state.bus.$emit("hidingSearch", false);

                        }

                    }
                    else {
                        this.$store.state.bus.$emit("hidingSearch", true);
                    }

                }


                //     else {
                //         document.getElementById("customsearch").style.top = "100px";
                //         document.getElementById("custom-nav-bar").style.display = "none";
                //         document.getElementById("page-content").style.padding = "0px";

                //         // this.afterScrolledStyle = { top: '100px' }

                //     }
                //     prevScrollpos = currentScrollPos;

                // }
                if ((vm.filterObj && vm.filterObj.Adults == -99 && vm.showAdultandChildrenDropdown == true && vm.showguestdropdown == false) || (vm.filterObj.Persons && vm.filterObj.Persons == -99 && vm.showguestdropdown == true && vm.showAdultandChildrenDropdown == false) || vm.isTrueOrFalse) {

                    if ((vm.filterObj && vm.filterObj.Adults == -99 && vm.showAdultandChildrenDropdown == true && vm.showguestdropdown == false) || (vm.filterObj.Persons && vm.filterObj.Persons == -99 && vm.showguestdropdown == true && vm.showAdultandChildrenDropdown == false)) {
                        vm.showError = true;
                    }
                    else {
                        vm.showError = false;
                    }
                    if (vm.isTrueOrFalse) {
                        vm.showCalenderError = true
                    }
                    else {
                        vm.showCalenderError = false;
                    }
                    if (window.outerWidth < 1920) {
                        vm.showSearch = true;
                        // this.$store.state.bus.$emit("MaskingUnits", false);
                    }

                    // return;
                }
                else {
                    vm.showError = false;
                    vm.showCalenderError = false;
                    if (window.outerWidth < 1920) {
                        vm.showSearch = false;
                        // this.$store.state.bus.$emit("MaskingUnits", false);
                    }
                    vm.getAvailableRooms();

                }

                // if(vm.showError == true && vm.showCalenderError == true){
                //     return;
                // }


                // if (vm.filterObj && vm.filterObj.Adults == -99 && vm.showAdultandChildrenDropdown == true && vm.showguestdropdown == false) {
                //     vm.showError = true;
                // }
                // else {
                //     vm.showAdultError = false;
                // }
                // if (vm.filterObj && vm.filterObj.Children == -99 && vm.showAdultandChildrenDropdown == true && vm.showguestdropdown == false) {
                //     vm.showChildrenError = true;
                // }
                // else {
                //     vm.showChildrenError = false;
                // }

                // if (vm.filterObj.Persons && vm.filterObj.Persons == -99 && vm.showguestdropdown == true && vm.showAdultandChildrenDropdown == false) {
                //     vm.showguestError = true;
                // }
                // else {
                //     vm.showguestError = false;
                // }




                // var dropdown = document.getElementById(elementId);
                // try {
                //     vm.showDropdown(dropdown);
                // } catch(e) {

                // }
                // return false;

                // vm.filterObj.FilteredAmenities = [];
                // if (vm.amenitiesList && vm.amenitiesList.length > 0) {
                //     for (
                //         let amenitiesListIndex = 0;
                //         amenitiesListIndex < vm.amenitiesList.length;
                //         amenitiesListIndex++
                //     ) {
                //         if (Number(vm.amenitiesList[amenitiesListIndex]["IsChecked"])) {
                //             console.log(
                //                 "ami name ====>>",
                //                 vm.amenitiesList[amenitiesListIndex].ListName
                //             );
                //             vm.filterObj.FilteredAmenities.push(
                //                 vm.amenitiesList[amenitiesListIndex]["ListId"]
                //             );
                //         }
                //     }
                // }     
                if(vm.$gtag){          
                    vm.$gtag.event("Search for available units", {
                        'event_category': 'Search availability',
                        'event_label': 'Search availability',
                    })
                }
                if ((vm.filterObj.Persons != '-99') || (vm.filterObj.Adults != '-99')) {
                    vm.getAvailableRooms();
                }
                vm.$store.state.bus.$emit("hideMaskpanel", false);
                vm.isShow = true;
                vm.showfiltereditpanelmask = false
                // vm.$store.state.bus.$emit('observe-visibility'); 
            },
            // showDropdown(element) {
            //     console.log("element==========>", element);
            //     var event;
            //     event = document.createEvent('MouseEvents');
            //     event.initMouseEvent('click', true, true, window);
            //     element.dispatchEvent(event);
            // },


            getAvailableRooms() {
                // $(".myTab").focus(function () {

                //     var length = $('.myTab option').length;
                //     //open dropdown
                //     $(this).attr('size', length);

                //     // to close
                //     $(this).attr('size', 1);
                // });
                console.log("aminities search")
                let vm = this;
                vm.filterObj.PageNo = 1;
                vm.filterObj.FilteredAmenities = [];
                if (vm.amenitiesList && vm.amenitiesList.length > 0) {
                    for (
                        let amenitiesListIndex = 0;
                        amenitiesListIndex < vm.amenitiesList.length;
                        amenitiesListIndex++
                    ) {
                        if (vm.amenitiesList[amenitiesListIndex]["isChecked"] == true) {
                            console.log(
                                "ami name ====>>",
                                vm.amenitiesList[amenitiesListIndex].ListName
                            );
                            vm.filterObj.FilteredAmenities.push(
                                vm.amenitiesList[amenitiesListIndex]["ListId"]
                            );
                        }
                    }
                }

                vm.pannel = false;
                setTimeout(() => {
                    vm.isShow = true
                }, 400)

                console.log("here", vm.filterObj);
                // vm.GetFiltersData_BE();
                vm.setAvailableUnitsData();
                if (vm.isTrueOrFalse) {
                    vm.$store.state.filterObj.startDate = null;
                    vm.$store.state.filterObj.endDate = null;
                }
                vm.$store.state.bus.$emit('callForAvailableunits', 'call');
                vm.$router.push("/availabilitySearch");
                // if (vm.showguestdropdown && (vm.$store.state.filterObj.startDate != null && vm.$store.state.filterObj.endDate != null)) {
                //     vm.$router.push({path:"/availabilitySearch",query:{Location:vm.filterObj.Location.CityName, Guests:vm.filterObj.Persons, CheckIn:moment.utc(vm.filterObj.startDate).format("YYYY-MM-DD"), CheckOut:moment.utc(vm.filterObj.endDate).format("YYYY-MM-DD")}});
                // } else if (vm.showguestdropdown && (vm.$store.state.filterObj.startDate == null && vm.$store.state.filterObj.endDate == null)) {
                //     vm.$router.push({path:"/availabilitySearch",query:{Location:vm.filterObj.Location.CityName, Guests:vm.filterObj.Persons}});
                // } 

                // if (vm.showAdultandChildrenDropdown && (vm.$store.state.filterObj.startDate != null && vm.$store.state.filterObj.endDate != null)) {
                //     vm.$router.push({path:"/availabilitySearch",query:{Location:vm.filterObj.Location.CityName, Adults:vm.filterObj.Adults, Children:vm.filterObj.Children, CheckIn:moment.utc(vm.filterObj.startDate).format("YYYY-MM-DD"), CheckOut:moment.utc(vm.filterObj.endDate).format("YYYY-MM-DD")}});
                // } else if (vm.showAdultandChildrenDropdown && (vm.$store.state.filterObj.startDate == null && vm.$store.state.filterObj.endDate == null)) {
                //     vm.$router.push({path:"/availabilitySearch",query:{Location:vm.filterObj.Location.CityName, Adults:vm.filterObj.Adults, Children:vm.filterObj.Children}});
                // }
            },
            setFilteredData() {
                let vm = this;
                this.$store.dispatch("setFilteredData", {
                    data: {
                        amenities: vm.amenitiesList,
                        locationsList: vm.locationsList,
                        demo3: vm.demo3,
                        showguestdropdown: vm.showguestdropdown

                    }
                })
            },
            setAvailableUnitsData() {
                let vm = this;
                console.log("filterObj", vm.filterObj)
                vm.filterObj.showguestdropdown = vm.showguestdropdown;
                // vm.$set(
                //   vm.filterObj.value,
                //   "value",
                //   vm.value
                // );
                this.$store.dispatch("setAvailableUnitsData", {
                    data: {
                        filterObj: JSON.parse(JSON.stringify(vm.filterObj)),
                    }
                })
            },
            onLocationChange() {
                let vm=this;
                vm.getAvailableRooms();
                if(vm.$gtag){
                    vm.$gtag.event("Search for available units on location", {
                        'event_category': 'Search availability on location',
                        'event_label': 'Search availability on location',
                    })
                }
            },
            fetchData() {
                // $route.name != 'guestInfoDetails' && $route.name != 'ThankYouPage' && $route.name != 'UnitDetails' &&  $route.name != 'termsAndConditions' 
                console.log("route changed! ", this.$route);

                // let vm = this;
                // vm.filterObj.Persons = vm.defaultSelection.DefaultnoofGuests == 0 ? -99 : vm.defaultSelection.DefaultnoofGuests;
                // vm.filterObj.Children = vm.defaultSelection.Defaultnoofchildren == 0 ? -99 : vm.defaultSelection.Defaultnoofchildren;
                // vm.filterObj.Adults = vm.defaultSelection.Defaultnoofadults == 0 ? -99 : vm.defaultSelection.Defaultnoofadults;
                // if (vm.defaultSelection.DefaultLocationName != -99) {
                //     vm.filterObj.Location = vm.locationsList.filter(function (item) {
                //         return item.CityName == vm.defaultSelection.DefaultLocationName
                //     })[0];
                // }
                // vm.filterObj.startDate = null;
                // vm.filterObj.endDate = null;
                // vm.filterObj.value= [null, null];
                // vm.filterObj.Persons= -99;
                // vm.filterObj.Adults= -99;
                // vm.filterObj.Children= -99;
                // vm.filterObj.startDate= moment.utc().format("YYYY-MM-DD");
                // vm.filterObj.endDate= moment.utc().format("YYYY-MM-DD");
                // vm.filterObj.Location= -99;
                // vm.filterObj.ClientId= 7;
                // vm.filterObj.FilteredAmenities= [];
                // vm.filterObj.amenitiesFiltered= [];
                // vm.filterObj.Beds= 0;
                // vm.filterObj.Bathrooms= 0;
                // vm.filterObj.Beds= 0;
                // vm.filterObj.Bedrooms= 0;
                // vm.filterObj.PageNo= 1;
                // vm.filterObj.ItemsPerPage= 20;
                // vm.filterObj.unitId= null;
                // vm.setAvailableUnitsData();
                // if (this.$route.name == 'availabilitySearch') {
                //     console.log("vm.filterObj before set", this.filterObj)
                //     Object.assign(this.$data, this.$options.data());
                //     console.log("vm.filterObj after set", this.filterObj)
                //     this.setAvailableUnitsData();
                //     this.GetFiltersData_BE();
                //     this.getAvailableRooms();
                //     this.filterObj.startDate = moment.utc().format("YYYY-MM-DD");
                //     this.filterObj.endDate = moment.utc().format("YYYY-MM-DD");
                //     this.$store.state.filterObj.startDate = null;
                //     this.$store.state.filterObj.endDate = null;
                // }

                // this.showNav

            },
            ipad() {
                this.showSearch = true
                if (window.outerWidth <= 768) {
                    this.showSearch = false
                } else {

                }
            },
            ipadRotate() {
                if (window.outerWidth <= 768) {
                    this.showSearch = false
                } else {
                    // this.showSearch = true
                }

            },
            openSearch() {
                let vm = this;
                vm.showSearch = true;
                vm.hideSearch = false;
                vm.$store.state.bus.$emit("hideMaskpanel", false);
                vm.isShow = false;
                vm.showfiltereditpanelmask = true

            },

            openTimes() {
                this.showSearch = false;
                this.hideSearch = true;
                // document.getElementById("customsearch").style.top = "20px";
                this.pannel = false;
                setTimeout(() => {
                    this.isShow = true
                }, 400)


            },
            // openSearch() {
            //     // this.showSearch = !this.showSearch;
            //     this.showSearch = true;
            //     this.hideSearch = true;
            //     // document.getElementById("customsearch").style.top = "0px";

            //     var prevScrollpos = window.pageYOffset;
            //     console.log("prevScrollpos", prevScrollpos)
            //     if (window.innerWidth <= 414 && this.showSearch == true) {

            //         if (this.scrollPOS.prevScrollpos < this.scrollPOS.currentScrollPos) {
            //             document.getElementById("customsearch").style.top = "20px";

            //         }
            //         else if (this.scrollPOS.prevScrollpos > this.scrollPOS.currentScrollPos) {
            //             document.getElementById("customsearch").style.top = "20px";
            //         }
            //         else {
            //             document.getElementById("customsearch").style.top = "20px";
            //         }
            //         document.getElementById("customsearch").style.padding = "";
            //         this.$store.state.bus.$emit("MaskingUnits", true);
            //     }
            //     else if (window.innerWidth <= 414 && this.showSearch == false) {
            //         if (this.scrollPOS.prevScrollpos < this.scrollPOS.currentScrollPos) {
            //             this.afterScrolledStyle = { top: '20px' }
            //         }
            //         else if (this.scrollPOS.prevScrollpos > this.scrollPOS.currentScrollPos) {
            //             this.afterScrolledStyle = { top: '20px' }
            //         }
            //         else if (this.scrollPOS.prevScrollpos == undefined || this.scrollPOS.currentScrollPos== undefined) {
            //             document.getElementById("custom-nav-bar").style.display = "none";
            //             document.getElementById("page-content").style.padding = "0px";
            //         document.getElementById("ListCount").style.top = "30px";
            //             this.afterScrolledStyle = { top: '20px' }
            //         }  

            //         else {
            //             this.afterScrolledStyle = { top: '100px' }
            //         }
            //         this.$store.state.bus.$emit("MaskingUnits", false);
            //     }
            //     else
            //         if (window.innerWidth > window.innerHeight) {
            //             this.setPosition = { top: '12px', position: "" }
            //         }
            //         else {
            //             this.setPosition = {
            //                 position: 'relative',
            //                 top: '12px'
            //             }
            //         }
            // }
        },
        computed: {
            isVaildSubDomain() {

                let vm = this;
                return vm.$store.state.isValidDomainOrNot;
            },
            showNav() {

                if (this.$route.name != 'unitDetailPage' && this.$route.name != 'guestInfo' && this.$route.name != 'paymentInfo' && this.$route.name != 'ThankYouPage' && this.$route.name != 'UnitDetails' && this.$route.name != 'termsAndConditions') {
                    console.log("here it is showNav true", this.$route.name);
                    return true;
                }
                else {
                    console.log("here it is showNav false");
                    return false;
                }
            }
        },
        created() {
            let vm = this;
            vm.$store.state.bus.$on("startAndEndTexts", function (selected) {

                vm.filterObj.startDate = selected.startDate;
                vm.filterObj.endDate = selected.endDate;

            });
            vm.$store.state.bus.$on("scrollPOS", function (scrollPOS) {

                vm.scrollPOS = scrollPOS;
            });
            vm.$store.state.bus.$on("IsShowSearch", function (bit) {
                vm.showSearch = bit;
                vm.hideSearch = false;
                // vm.isShow = false;
                vm.showfiltereditpanelmask = true

            });

            vm.$store.state.bus.$on("clearSearch", function (bit) {
                vm.closeHeaderPannel();
            });
            vm.$store.state.bus.$on("defaultsearchfromfiles", function (bit) {
                if (vm.defaultSelection.GuestPattern == "Persons") {
                    vm.$store.state.filterObj.Persons = vm.defaultSelection.DefaultnoofGuests == 0 ? 2 : vm.defaultSelection.DefaultnoofGuests;
                    vm.filterObj.Persons = vm.defaultSelection.DefaultnoofGuests == 0 ? 2 : vm.defaultSelection.DefaultnoofGuests;
                }
                else {
                    vm.$store.state.filterObj.Children = vm.defaultSelection.Defaultnoofchildren == 0 ? -99 : vm.defaultSelection.Defaultnoofchildren;
                    vm.$store.state.filterObj.Adults = vm.defaultSelection.Defaultnoofadults == 0 ? 2 : vm.defaultSelection.Defaultnoofadults;
                    vm.filterObj.Children = vm.defaultSelection.Defaultnoofchildren == 0 ? -99 : vm.defaultSelection.Defaultnoofchildren;
                    vm.filterObj.Adults = vm.defaultSelection.Defaultnoofadults == 0 ? 2 : vm.defaultSelection.Defaultnoofadults;
                }
                if (vm.defaultSelection.DefaultLocationName != -99) {
                    let selectedDefaultLocation = vm.locationsList.filter(function (item) {
                        return item.CityName == vm.defaultSelection.DefaultLocationName
                    })[0];
                    vm.$store.state.filterObj.Location = selectedDefaultLocation
                    vm.filterObj.Location = selectedDefaultLocation
                } else {
                    vm.$store.state.filterObj.Location = vm.defaultSelection.DefaultLocationName
                    vm.filterObj.Location = vm.defaultSelection.DefaultLocationName
                }

                vm.filterObj.startDate = moment().format()
                vm.disablePrevDates = true
                // vm.filterObj.Persons = vm.defaultSelection.DefaultnoofGuests == 0 ? -99 : vm.defaultSelection.DefaultnoofGuests;
                // vm.filterObj.Children = vm.defaultSelection.Defaultnoofchildren == 0 ? -99 : vm.defaultSelection.Defaultnoofchildren;
                // vm.filterObj.Adults = vm.defaultSelection.Defaultnoofadults == 0 ? -99 : vm.defaultSelection.Defaultnoofadults;
                // if (vm.defaultSelection.DefaultLocationName != -99) {
                //     vm.filterObj.Location = vm.locationsList.filter(function (item) {
                //         return item.CityName == vm.defaultSelection.DefaultLocationName
                //     })[0];
                // }
                vm.$store.state.bus.$emit("hidingSearch", true);
            });
            if (window.innerWidth === 1024 && (window.innerHeight === 1366 || window.innerHeight === 768)) {
                vm.showMobileSearch = true;
            }
            else {
                vm.showMobileSearch = false;
            }

            vm.$store.state.bus.$on("updateSearchData", function (selected) {

                vm.filterObj = selected;
                vm.filterObj.startDate = moment.utc().format("YYYY-MM-DD");
                vm.filterObj.endDate = moment.utc().format("YYYY-MM-DD");
                if (vm.defaultSelection.GuestPattern == "Persons") {
                    vm.$store.state.filterObj.Persons = vm.defaultSelection.DefaultnoofGuests == 0 ? 2 : vm.defaultSelection.DefaultnoofGuests;
                    vm.filterObj.Persons = vm.defaultSelection.DefaultnoofGuests == 0 ? 2 : vm.defaultSelection.DefaultnoofGuests;
                }
                else {
                    vm.$store.state.filterObj.Children = vm.defaultSelection.Defaultnoofchildren == 0 ? -99 : vm.defaultSelection.Defaultnoofchildren;
                    vm.$store.state.filterObj.Adults = vm.defaultSelection.Defaultnoofadults == 0 ? 2 : vm.defaultSelection.Defaultnoofadults;
                    vm.filterObj.Children = vm.defaultSelection.Defaultnoofchildren == 0 ? -99 : vm.defaultSelection.Defaultnoofchildren;
                    vm.filterObj.Adults = vm.defaultSelection.Defaultnoofadults == 0 ? 2 : vm.defaultSelection.Defaultnoofadults;
                }
                if (vm.defaultSelection.DefaultLocationName != -99) {
                    let selectedDefaultLocation = vm.locationsList.filter(function (item) {
                        return item.CityName == vm.defaultSelection.DefaultLocationName
                    })[0];
                    vm.$store.state.filterObj.Location = selectedDefaultLocation
                    vm.filterObj.Location = selectedDefaultLocation
                } else {
                    vm.$store.state.filterObj.Location = vm.defaultSelection.DefaultLocationName
                    vm.filterObj.Location = vm.defaultSelection.DefaultLocationName
                }
                // vm.filterObj.Persons = vm.defaultSelection.DefaultnoofGuests == 0 ? -99 : vm.defaultSelection.DefaultnoofGuests;
                // vm.filterObj.Children = vm.defaultSelection.Defaultnoofchildren == 0 ? -99 : vm.defaultSelection.Defaultnoofchildren;
                // vm.filterObj.Adults = vm.defaultSelection.Defaultnoofadults == 0 ? -99 : vm.defaultSelection.Defaultnoofadults;
                // if (vm.defaultSelection.DefaultLocationName != -99) {
                //     vm.filterObj.Location = vm.locationsList.filter(function (item) {
                //         return item.CityName == vm.defaultSelection.DefaultLocationName
                //     })[0];
                // }
                // vm.closeHeaderPannel()
                vm.$store.state.bus.$emit("hidingSearch", true);
                document.getElementById("page-content").style.padding = "";
                // $(".booking-eng.beFilterBar.pushIt").removeClass("DatesFilter");
                vm.IsDatesFilter = false;
                // document.getElementsByClassName(".searchWrap.DatesFilter").style.marginTop = "0px";
            });
        },
        watch: {
            isVaildSubDomain(isAvail) {

                if (isAvail) {
                    this.GetFiltersData_BE();
                }
            },
            $route: "fetchData"
        },
        mounted() {
            let vm = this;
            console.log("filterObj", vm.filterObj)
            vm.$store.state.bus.$on("shoppingCart", function () {

                vm.filterObj.startDate = null,
                    vm.filterObj.endDate = null,
                    // vm.filterObj.Persons = -99,
                    // vm.filterObj.Adults = -99,
                    // vm.filterObj.Children = -99,
                    // vm.filterObj.Location = -99,
                    vm.filterObj.Promocode = null,
                    // vm.updateCalendar = true
                    vm.minDate = null; // Temporarily set to null
                    vm.$nextTick(() => {
                        vm.minDate = moment().format("DD MMM YYYY"); // Assign the original value
                        vm.getAvailableRooms();
                    });
                    //     vm.filterObj.FilteredAmenities = [],
                    //     vm.filterObj.Beds = 0,
                    //     vm.filterObj.Bathrooms = 0,
                    //     vm.filterObj.Beds = 0,
                    //     vm.filterObj.Bedrooms = 0
                    // vm.filterObj.value = [null, null]

                    

            });
            vm.$store.state.bus.$on("moreOptionPannel", function (showValue) {
                if (showValue) {
                    vm.isShow = false;
                    vm.pannel = true;
                } else {
                    vm.isShow = true;
                    vm.pannel = false;
                }
            });
            vm.$store.state.bus.$on("DatesPannel", function (showValue) {
                if (showValue) {
                    vm.showfiltereditpanelmask = true
                    vm.showSearch = true;
                } else {
                    vm.showfiltereditpanelmask = false
                    vm.showSearch = false;
                }

                // this.hideSearch = false;
                console.log("this.showSearch", vm.showSearch)
            });

            vm.$store.state.bus.$on("mapWidth", function (value) {
                vm.mapWidth = value;
                if (vm.mapWidth <= 512) {
                    vm.showApplyAndCancelBtn = true;

                }
                else {
                    vm.showApplyAndCancelBtn = false;
                }

                console.log("this.mapWidth", vm.mapWidth)
            });






            // vm.getAvailableRooms();
            // vm.GetFiltersData_BE();
            // vm.validate();
            this.ipad();
            // window.addEventListener('resize', this.ipadRotate);


        }
    }

</script>


// WEBPACK FOOTER //
// src/components/homeModule/searchNavComponent/searchNavComponent.vue